import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpCommonActions } from "../../actions/mp-common.actions";
import { RfPolarizationState } from "../../models/mp-common/rf-polarization.state";

const initialState: RfPolarizationState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpCommonActions.rfPolarization.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		rfPolarization: action.rfPolarization
	})),
	on(MpCommonActions.rfPolarization.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	}))
);

export function rfPolarizationReducer(
	state: RfPolarizationState | undefined,
	action: Action
): RfPolarizationState {
	return reducer(state, action);
}
